module.exports = __webpack_public_path__ + "static/media/signin-background-light.732e53fa.jpg";